import manifest from "../data/imageManifest.json";

// Responsive self-hosted WebP image; falls back to a plain <img> for unknown sources.
const Img = ({ src, sizes = "100vw", priority = false, alt = "", ...rest }) => {
    const meta = manifest[src];
    const loading = priority ? { loading: "eager", fetchPriority: "high" } : { loading: "lazy" };
    if (!meta) return <img src={src} alt={alt} decoding="async" {...loading} {...rest} />;
    const fallback = meta.widths.find((w) => w >= 1280) || meta.w;
    return (
        <img
            src={`${src}-${fallback}.webp`}
            srcSet={meta.widths.map((w) => `${src}-${w}.webp ${w}w`).join(", ")}
            sizes={sizes}
            width={meta.w}
            height={meta.h}
            alt={alt}
            decoding="async"
            {...loading}
            {...rest}
        />
    );
};

export default Img;
